import { c as classesToSelector } from '../../../../../../node_modules/swiper/shared/classes-to-selector.mjs';
import { c as createElement, g as elementIndex } from '../../../../../../node_modules/swiper/shared/utils.mjs';
import { de } from './de.js';

function A11y(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    a11y: {
      enabled: true,
      containerRole: 'region',
      slideRole: 'group',
      id: null,
      ...de,
    },
  });
  swiper.a11y = {
    clicked: false,
  };
  let liveRegion = null;
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.innerHTML = '';
    notification.innerHTML = message;
  }
  const makeElementsArray = el => {
    if (!Array.isArray(el)) el = [el].filter(e => !!e);
    return el;
  };
  function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return 'x'.repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.removeAttribute('tabIndex');
    });
  }
  function makeElNotFocusable(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '-1');
    });
  }
  function addElRole(el, role) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('role', role);
    });
  }
  function addElRoleDescription(el, description) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-roledescription', description);
    });
  }
  function addElControls(el, controls) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-controls', controls);
    });
  }
  function addElLabel(el, label) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-label', label);
    });
  }
  function addElId(el, id) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('id', id);
    });
  }
  function addElLive(el, live) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-live', live);
    });
  }
  function disableEl(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', true);
    });
  }
  function enableEl(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', false);
    });
  }
  function elementChildren(element, selector) {
    if (selector === void 0) {
      selector = '';
    }
    return [...element.children].filter(el => el.matches(selector));
  }
  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const targetEl = e.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
      if (!e.target.matches(classesToSelector(swiper.params.pagination.bulletClass))) return;
    }
    if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }
      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }
    if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }
      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }
    if (swiper.pagination && targetEl.matches(classesToSelector(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function getActiveSlide() {
    const params = swiper.params;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const slides = swiper.slides;
    const slidesEl = swiper.slidesEl;
    const activeIndex = swiper.activeIndex;
    const getFilteredSlide = selector => {
      return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    slides.forEach(slideEl => {
      slideEl.setAttribute('hidden', 'hidden');
    });
    let activeSlide;
    if (isVirtual) {
      if (params.loop) {
        let slideIndex = activeIndex - swiper.virtual.slidesBefore;
        if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
        if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
      } else {
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
      }
    } else {
      activeSlide = slides[activeIndex];
    }

    return activeSlide;
  }
  function focusHideContent(el) {
    if (!el) return;
    const focusables = el.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    focusables.forEach(focusable => {
      focusable.setAttribute('data-tabindex-disabled', true);
      if (focusable.getAttribute('tabindex'))
        focusable.setAttribute(
          'data-tabindex-disabled',
          focusable.getAttribute('tabindex')
        );
      focusable.setAttribute('tabindex', '-1');
    });
  }
  function focusRevealContent(el) {
    if (!el) return;
    const focusables = el.querySelectorAll('[data-tabindex-disabled]');
    focusables.forEach(focusable => {
      focusable.removeAttribute('data-tabindex-disabled');
      if (
        focusable?.dataset?.tabindexDisabled &&
        focusable.dataset.tabindexDisabled !== 'true'
      ) {
        focusable.setAttribute('tabindex', focusable.dataset.tabindexDisabled);
        return;
      }
      focusable.removeAttribute('tabindex');
    });
  }
  // function focusActiveSlide() {
  //   const activeSlide = getActiveSlide();
  //   activeSlide.focus();
  // }
  function updateSlides() {
    const activeSlide = getActiveSlide();
    const slides = swiper.slides;
    slides.forEach((slideEl, index) => {
      if (
        !swiper.params.loop &&
        swiper.slides.length < 2 * swiper.params.slidesPerView &&
        index > swiper.activeIndex &&
        index < swiper.activeIndex + swiper.params.slidesPerView
      ) {
        slideEl.removeAttribute('hidden');
        slideEl.setAttribute('tabindex', '-1');
        focusRevealContent(slideEl);

        return;
      }

      slideEl.removeAttribute('tabindex');
      slideEl.setAttribute('hidden', 'hidden');
      focusHideContent(slideEl);
    });

    if (activeSlide) {
      activeSlide.removeAttribute('hidden');
      activeSlide.setAttribute('tabindex', '-1');
      focusRevealContent(activeSlide);
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.forEach(bulletEl => {
      addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(bulletEl) + 1));
      if (bulletEl.matches(classesToSelector(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute('aria-current', 'true');
      } else {
        bulletEl.removeAttribute('aria-current');
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== 'BUTTON') {
      addElRole(el, 'button');
      el.addEventListener('keydown', onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const initPagination = () => {
    if (swiper.params.pagination) {
      swiper.params.pagination.clickable = true;
      swiper.params.pagination.bulletElement = 'button';
    }
  };
  const initCounter = () => {
    if (swiper.params.pagination.type === 'fraction') {
      swiper.el
        .querySelector(swiper.params.pagination.el)
        .setAttribute('aria-live', 'polite');
      return;
    }
    const a11yCounter = createElement('span', swiper.params.a11y.counterClass);
    a11yCounter.setAttribute('aria-live', 'polite');
    a11yCounter.setAttribute('aria-atomic', 'true');
    swiper.el.append(a11yCounter);
    updateCounter();
  };
  const updateCounter = () => {
    const counter = swiper.el.querySelector(
      `.${swiper.params.a11y.counterClass}`
    );
    if (!counter) return;
    counter.innerHTML = `${swiper.params.a11y.counterMessage
      .replace(/\{\{index\}\}/, swiper.realIndex + 1)
      .replace(/\{\{slidesLength\}\}/, swiper.slides.length)}`;
  }
  const handlePointerDown = () => {
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const handleFocus = e => {
    if (swiper.a11y.clicked) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    if (
      !swiper.params.loop &&
      swiper.slides.length < 2 * swiper.params.slidesPerView
    )
      return;
    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };
  const initSkipLink = wrapperId => {
    const params = swiper.params.a11y;
    if (!params.skipLinkMessage) return;

    const link = document.createElement('div');
    const target = document.createElement('div');

    link.classList.add('skip-link');
    link.innerHTML = `<a href="#skip-link-target-${wrapperId}" class="skip-link__link"><span>${params.skipLinkMessage}</span></a>`;

    target.setAttribute('id', `skip-link-target-${wrapperId}`);
    target.setAttribute('tabindex', '-1');
    target.setAttribute('aria-hidden', true);

    swiper.el.prepend(link);
    swiper.el.append(target);
  };

  const removeSkipLink = el => {
    const params = swiper.params.a11y;
    if (!params.skipLinkMessage) return;

    const skipLinksAndTargets = [... el.querySelectorAll('.skip-link'), ...el.querySelectorAll('[id*=skip-link-target]')];

    skipLinksAndTargets.forEach(item => {
      item.remove();
    })
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);

    // Container
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerRole) {
      addElRole(containerEl, params.containerRole);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }

    // Wrapper
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId(wrapperEl, wrapperId);
    addElLive(wrapperEl, live);

    // Slide
    initSlides();

    // Counter
    initCounter();

    // Navigation
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach(el => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach(el => initNavEl(el, wrapperId, params.prevSlideMessage));
    }

    // Pagination
    addElControls(swiper.pagination.bullets, wrapperId);
    if (hasClickablePagination()) {
      const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [swiper.pagination.el];
      paginationEl.forEach(el => {
        el.addEventListener('keydown', onEnterOrSpaceKey);
      });
    }

    // Skip links
    initSkipLink(wrapperId);

    // Tab focus
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('pointerdown', handlePointerDown, true);
    swiper.el.addEventListener('pointerup', handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion) liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [swiper.pagination.el];
      paginationEl.forEach(el => {
        el.removeEventListener('keydown', onEnterOrSpaceKey);
      });
    }

    // Skip links
    removeSkipLink(swiper.el);

    // Tab focus
    swiper.el.removeEventListener('focus', handleFocus, true);
    swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
    swiper.el.removeEventListener('pointerup', handlePointerUp, true);
  }
  on('beforeInit', () => {
    // if (!swiper.params.a11y.enabled) return;

    // // Ensure counter works correctly, see prerequisites for the correct working of loop https://swiperjs.com/swiper-api#param-loop
    // swiper.params.loop =
    //   swiper.slides.length >= swiper.params.slidesPerView * 2;
    liveRegion = createElement('span', swiper.params.a11y.notificationClass);
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
    initPagination();
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
    updateSlides();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('activeIndexChange', () => {
    if (!swiper.params.a11y.enabled) return;
    updateSlides();
    if (!(swiper.params.pagination.type === 'fraction')) updateCounter();
    // focusActiveSlide();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}

export { A11y };
